import { render, staticRenderFns } from "./OldUnionBody.vue?vue&type=template&id=e0361b64&scoped=true"
import script from "./OldUnionBody.vue?vue&type=script&lang=js"
export * from "./OldUnionBody.vue?vue&type=script&lang=js"
import style0 from "./OldUnionBody.vue?vue&type=style&index=0&id=e0361b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0361b64",
  null
  
)

export default component.exports